import React from  "react";

const Family = (props) => {


   return (
      <section className="feature">
           <div className="feature-description">
            <h1>It's All About Family</h1>
            <ul>
               <li>I was born in Wichita, Kansas</li>
               <li>I have a blended family (a yours mine and ours). My parents have been together for 27 years </li>
               <li>My father is the second of ten children. His mother is the second of 15 children. <br></br>Believe it or not, his grandmother was one of 21 children</li>
               <li>I have five CRAZY sisters who keep me on my toes </li>
               <li>Two brother-in-law positions are currently available and applications are being accepted</li> 
            </ul>
         </div>
     
      </section>
   )
}
export default Family;